import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

export type EditDomainButtonProps = Readonly<{
    onClick: () => void;
}>;

export function EditDomainButton(props: EditDomainButtonProps) {
    return (
        <ButtonWidget
            testId="edit-domain-button"
            buttonType={ButtonType.Icon}
            onClick={props.onClick}
            title={Messages.bridgeSiteSettingsEditDomain()}
            aria-label={Messages.bridgeSiteSettingsEditDomain()}
        >
            <img src={imgPath('pencil_14px_small.svg')} alt={''} aria-hidden={true} />
        </ButtonWidget>
    );
}
